// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8dbf9f74","455":"49137da5","977":"d2b4b022"}[chunkId] + ".chunk.js";
};